import { TranslationService } from '../Translation'
import { BaseNavigation } from './baseNavigation'

export class ExploreNavigation extends BaseNavigation {
	static path: string = 'explore'

	static go(): unknown {
		return this.navigateTo(this.exploreURL())
	}

	static exploreURL(): string {
		const translation = TranslationService.getInstance()
		return `/${translation.getLocale()}/${this.path}/`
	}
}
